import { useEffect, useRef } from "react";

export const useScrollToAnchor = ({ anchor, direction = "down", isLoading }) => {
    const userScrolled = useRef(false);

    const scrollToAnchor = (force = false) => {
        if (!force && userScrolled.current) {
            return;
        }

        const el = document.getElementById(anchor);
        if (el) {
            const offset = direction === "up" ? 150 : 120;
            const top = el.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({ top, behavior: "smooth" });
        }
    };

    useEffect(() => {
        window.history.scrollRestoration = "manual";

        const onUserScroll = () => {
            userScrolled.current = true;
        };

        const handleNav = () => {
            if (isLoading) return;
            const hash = window.location.hash?.substring(1);
            if (hash === anchor) {
                setTimeout(() => scrollToAnchor(true), 100);
            }
        };

        const initialTimeout = setTimeout(() => {
            const hash = window.location.hash?.substring(1);
            if (hash === anchor && !isLoading) {
                scrollToAnchor();
            }
        }, 300);

        window.addEventListener("scroll", onUserScroll, { once: true });
        window.addEventListener("hashchange", handleNav);
        window.addEventListener("popstate", handleNav);

        return () => {
            clearTimeout(initialTimeout);
            window.removeEventListener("scroll", onUserScroll);
            window.removeEventListener("hashchange", handleNav);
            window.removeEventListener("popstate", handleNav);
        };
    }, [anchor, direction, isLoading]);
};
